import { useEffect, useRef, useState } from 'react'
import type { Editor } from '@tiptap/core'
import { TextSelection } from '@tiptap/pm/state'

function findNext(editor: Editor, query: string): boolean {
  if (!query) return false
  const needle = query.toLocaleLowerCase()
  const start = editor.state.selection.to
  const matches: Array<{ from: number; to: number }> = []

  editor.state.doc.descendants((node, position) => {
    if (!node.isText || !node.text) return
    const text = node.text.toLocaleLowerCase()
    let offset = text.indexOf(needle)
    while (offset >= 0) {
      matches.push({ from: position + offset, to: position + offset + query.length })
      offset = text.indexOf(needle, offset + 1)
    }
  })

  const match = matches.find((item) => item.from >= start) ?? matches[0]
  if (!match) return false
  const transaction = editor.state.tr.setSelection(
    TextSelection.create(editor.state.doc, match.from, match.to),
  )
  editor.view.dispatch(transaction.scrollIntoView())
  editor.commands.focus()
  return true
}

export function FindBar({ editor, onClose }: { editor: Editor; onClose: () => void }) {
  const [query, setQuery] = useState('')
  const [found, setFound] = useState(true)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => inputRef.current?.focus(), [])

  return (
    <div className="find-bar" role="search">
      <input
        ref={inputRef}
        value={query}
        placeholder="在笔记中查找"
        onChange={(event) => {
          setQuery(event.target.value)
          setFound(true)
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') setFound(findNext(editor, query))
          if (event.key === 'Escape') onClose()
        }}
      />
      {!found && <span className="find-empty">未找到</span>}
      <button onClick={() => setFound(findNext(editor, query))}>下一个</button>
      <button className="icon-button" onClick={onClose} aria-label="关闭查找">×</button>
    </div>
  )
}
